import { Pagination } from '../../models/generic/pagination';
import { DocumentScope } from './response-document-subtype';

export const DEFAULT_PROJECT_NAME = 'Nouveau projet';

export interface DbResponseProject {
  id: number;
  name: string;
  is_active: boolean;
}

export interface PostResponseProjectsRequestBody {
  fields: string[];
  filters: Record<string, unknown>;
  limit: number;
  offset: number;
}

export interface ResponseProject {
  id: string;
  name: string;
  is_active?: boolean;
}

export interface DbResponseProjectDetail {
  id: number;
  name: string;
  user_id: number;
  user_instructions: string | null;
  created_at: string;
  updated_at: string;
  is_active: boolean;
}

export interface ResponseProjectDetail {
  id: string;
  name: string;
  user_id: number;
  user_instructions: string | null;
  created_at: string;
  updated_at: string;
  is_active: boolean;
}

export interface DbResponseProjectsApiResponse {
  data: DbResponseProject[];
  pagination: Pagination;
}

export interface ResponseProjects {
  data: ResponseProject[];
  pagination: Pagination;
}

export interface PutResponseProjectsRequestBody {
  name: string;
}

export interface PutResponseProjectsResponse {
  message: string;
  response_project_id: number;
}

export interface PatchResponseProjectsRequestBody {
  id: string;
  name?: string;
  user_instructions?: string;
  is_active?: boolean;
}

export interface ResponseProjectProcessingPayload {
  project_id?: number | null;
  user_token: string;
  scope: DocumentScope;
  files: Array<{ name: string; uid: string; id: number }>;
}

export interface ConflictResolutionMessage {
  action: 'replace' | 'keep';
  key: string;
  document_id?: number;
  document_subtype_id?: number;
}

export type ResponseProjectProcessingMessage =
  | { uid: string; status: 'extracting archive' }
  | { uid: string; status: 'Downloading archive' }
  | { filename: string; status: 'unzipping' }
  | { file_count: number; status: 'count' }
  | { uid: string; status: 'uploading'; filename: string }
  | { uid: string; status: 'uploaded'; filename: string; id: number; size: number }
  | { uid: string; status: 'categorizing' }
  | { uid: string; status: 'categorized'; subtype_id: number; custom_name?: string }
  | { status: 'processing_complete' }
  | { status: 'conflict_skipped'; conflict_key: string; filename: string }
  | { status: 'error'; reason: string; filename?: string; uid?: string | null; conflict_key?: string }
  | { status: 'renamed project'; project_name: string; project_id: number };

export enum ResponseProjetAiMessageScenario {
  WELCOME = 'welcome',
  RECEIVED = 'received',
  ADDED = 'added',
  REMOVED = 'removed',
  UPLOADING = 'uploading',
  CATEGORIZING = 'categorizing',
  FINALIZING = 'finalizing',
  WORKING = 'working',
  READY = 'ready',
  ASK_INTERNAL = 'ask-internal',
}
